module.exports = __webpack_public_path__ + "img/vcl2.caf1b0d7.webp";